import React from 'react';
import Box from '@mui/material/Box';

import { ArticleCard } from '@/components/atoms/ArticleCard/ArticleCard';
import { Carousel } from '@/components/atoms/Carousel/Carousel';

// store
import { Article, ArticleCategory } from '@karehero/models';

/**
 * ArticleSummary is a helper component that renders the library.
 */
export const ArticleSummary = ({
  library,
  bookmarkedArticles,
  onBookmark,
  onArticleClick,
  isLoading,
}: ArticleSummaryProps) => {
  if (!library || library.length === 0) {
    return null;
  }

  return (
    <>
      {library.map(
        (category) =>
          category?.articles?.length !== 0 && (
            <Carousel
              key={category?.title}
              title={category?.title}
              isLoading={isLoading}
              items={
                category?.articles?.map((article, i) => ({
                  id: article?.title || `${i}`,
                  renderItem: (
                    <Box
                      sx={{
                        minWidth: '250px',
                        width: '250px',
                        maxWidth: '250px',
                      }}
                    >
                      <ArticleCard
                        article={article}
                        isBookmarked={
                          !!bookmarkedArticles?.find(
                            (a) => a?._id === article?._id,
                          )
                        }
                        onBookmark={onBookmark}
                        onClick={onArticleClick}
                        isLoading={isLoading}
                      />
                    </Box>
                  ),
                })) || []
              }
            />
          ),
      )}
    </>
  );
};

interface ArticleSummaryProps {
  library?: ArticleCategory[];
  bookmarkedArticles?: Article[];
  onBookmark?: (article: Partial<Article>) => void;
  onArticleClick?: (article?: Partial<Article>) => void;
  isLoading: boolean;
}

ArticleSummary.displayName = 'ArticleSummary';

export default ArticleSummary;
